// source: v3/billing_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var v3_types_bill_run_pb = require('../v3/types/bill_run_pb.js');
goog.object.extend(proto, v3_types_bill_run_pb);
var v3_types_billing_adjustment_pb = require('../v3/types/billing_adjustment_pb.js');
goog.object.extend(proto, v3_types_billing_adjustment_pb);
var v3_types_billing_interval_pb = require('../v3/types/billing_interval_pb.js');
goog.object.extend(proto, v3_types_billing_interval_pb);
var v3_types_billing_mechanism_pb = require('../v3/types/billing_mechanism_pb.js');
goog.object.extend(proto, v3_types_billing_mechanism_pb);
var v3_types_invoice_pb = require('../v3/types/invoice_pb.js');
goog.object.extend(proto, v3_types_invoice_pb);
var v3_types_invoice_line_item_pb = require('../v3/types/invoice_line_item_pb.js');
goog.object.extend(proto, v3_types_invoice_line_item_pb);
var v3_types_pagination_pb = require('../v3/types/pagination_pb.js');
goog.object.extend(proto, v3_types_pagination_pb);
var v3_types_group_pb = require('../v3/types/group_pb.js');
goog.object.extend(proto, v3_types_group_pb);
var v3_types_purchased_product_pb = require('../v3/types/purchased_product_pb.js');
goog.object.extend(proto, v3_types_purchased_product_pb);
var v3_types_report_pb = require('../v3/types/report_pb.js');
goog.object.extend(proto, v3_types_report_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.IssueInvoiceRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.IssueInvoiceResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListBillRunsRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListBillRunsResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListBillingIntervalsRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListBillingIntervalsResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListInvoicesRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListInvoicesResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.RemovePurchasedProductRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.RemovePurchasedProductResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.SendInvoiceRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.SendInvoiceResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.displayName = 'proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse.displayName = 'proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.displayName = 'proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse.displayName = 'proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListBillingIntervalsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.displayName = 'proto.loopup.ctgateway.v3.ListBillingIntervalsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListBillingIntervalsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.displayName = 'proto.loopup.ctgateway.v3.ListBillingIntervalsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.displayName = 'proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.displayName = 'proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.displayName = 'proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.displayName = 'proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.displayName = 'proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse.displayName = 'proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.displayName = 'proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse.displayName = 'proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.displayName = 'proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse.displayName = 'proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.displayName = 'proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse.displayName = 'proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.displayName = 'proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.displayName = 'proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.displayName = 'proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.displayName = 'proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.displayName = 'proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse.displayName = 'proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.displayName = 'proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse.displayName = 'proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest.displayName = 'proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse.displayName = 'proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest.displayName = 'proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.displayName = 'proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.RemovePurchasedProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.RemovePurchasedProductRequest.displayName = 'proto.loopup.ctgateway.v3.RemovePurchasedProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.RemovePurchasedProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.RemovePurchasedProductResponse.displayName = 'proto.loopup.ctgateway.v3.RemovePurchasedProductResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.displayName = 'proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse.displayName = 'proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.SendInvoiceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.SendInvoiceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.SendInvoiceRequest.displayName = 'proto.loopup.ctgateway.v3.SendInvoiceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.SendInvoiceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.SendInvoiceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.SendInvoiceResponse.displayName = 'proto.loopup.ctgateway.v3.SendInvoiceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.IssueInvoiceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.IssueInvoiceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.IssueInvoiceRequest.displayName = 'proto.loopup.ctgateway.v3.IssueInvoiceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.IssueInvoiceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.IssueInvoiceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.IssueInvoiceResponse.displayName = 'proto.loopup.ctgateway.v3.IssueInvoiceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListInvoicesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListInvoicesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListInvoicesRequest.displayName = 'proto.loopup.ctgateway.v3.ListInvoicesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.ListInvoicesResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListInvoicesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListInvoicesResponse.displayName = 'proto.loopup.ctgateway.v3.ListInvoicesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest.displayName = 'proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse.displayName = 'proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest.displayName = 'proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse.displayName = 'proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListBillRunsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListBillRunsRequest.displayName = 'proto.loopup.ctgateway.v3.ListBillRunsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListBillRunsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.ListBillRunsResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListBillRunsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListBillRunsResponse.displayName = 'proto.loopup.ctgateway.v3.ListBillRunsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.displayName = 'proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse.displayName = 'proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProductId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 2, 0),
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    purchaseOrderReference: (f = msg.getPurchaseOrderReference()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    effectiveFromDateTime: (f = msg.getEffectiveFromDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    sku: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest;
  return proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurchasedProductId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPurchaseOrderReference(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveFromDateTime(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSku(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProductId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getPurchaseOrderReference();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEffectiveFromDateTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSku();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string purchased_product_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.getPurchasedProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.setPurchasedProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double price = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue purchase_order_reference = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.getPurchaseOrderReference = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.setPurchaseOrderReference = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.clearPurchaseOrderReference = function() {
  return this.setPurchaseOrderReference(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.hasPurchaseOrderReference = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp effective_from_date_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.getEffectiveFromDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.setEffectiveFromDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.clearEffectiveFromDateTime = function() {
  return this.setEffectiveFromDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.hasEffectiveFromDateTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string sku = 6;
 * @return {string}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.getSku = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductRequest.prototype.setSku = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProduct: (f = msg.getPurchasedProduct()) && v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse;
  return proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct;
      reader.readMessage(value,v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct.deserializeBinaryFromReader);
      msg.setPurchasedProduct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct.serializeBinaryToWriter
    );
  }
};


/**
 * optional PerSpecifiedQuantityPurchasedProduct purchased_product = 1;
 * @return {?proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse.prototype.getPurchasedProduct = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct} */ (
    jspb.Message.getWrapperField(this, v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse} returns this
*/
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse.prototype.setPurchasedProduct = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse} returns this
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse.prototype.clearPurchasedProduct = function() {
  return this.setPurchasedProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdateOneOffPerSpecifiedQuantityPurchasedProductResponse.prototype.hasPurchasedProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProductId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 2, 0),
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    purchaseOrderReference: (f = msg.getPurchaseOrderReference()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    effectiveFromDateTime: (f = msg.getEffectiveFromDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endDateTime: (f = msg.getEndDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    sku: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest;
  return proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurchasedProductId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPurchaseOrderReference(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveFromDateTime(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDateTime(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSku(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProductId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getPurchaseOrderReference();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEffectiveFromDateTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDateTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSku();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string purchased_product_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.getPurchasedProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.setPurchasedProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double price = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue purchase_order_reference = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.getPurchaseOrderReference = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.setPurchaseOrderReference = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.clearPurchaseOrderReference = function() {
  return this.setPurchaseOrderReference(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.hasPurchaseOrderReference = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp effective_from_date_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.getEffectiveFromDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.setEffectiveFromDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.clearEffectiveFromDateTime = function() {
  return this.setEffectiveFromDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.hasEffectiveFromDateTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp end_date_time = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.getEndDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.setEndDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.clearEndDateTime = function() {
  return this.setEndDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.hasEndDateTime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string sku = 7;
 * @return {string}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.getSku = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductRequest.prototype.setSku = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProduct: (f = msg.getPurchasedProduct()) && v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse;
  return proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct;
      reader.readMessage(value,v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct.deserializeBinaryFromReader);
      msg.setPurchasedProduct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct.serializeBinaryToWriter
    );
  }
};


/**
 * optional PerSpecifiedQuantityPurchasedProduct purchased_product = 1;
 * @return {?proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse.prototype.getPurchasedProduct = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct} */ (
    jspb.Message.getWrapperField(this, v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse} returns this
*/
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse.prototype.setPurchasedProduct = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse} returns this
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse.prototype.clearPurchasedProduct = function() {
  return this.setPurchasedProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdateRecurringPerSpecifiedQuantityPurchasedProductResponse.prototype.hasPurchasedProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListBillingIntervalsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListBillingIntervalsRequest}
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListBillingIntervalsRequest;
  return proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListBillingIntervalsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListBillingIntervalsRequest}
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListBillingIntervalsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string billing_entity_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.prototype.getBillingEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.ListBillingIntervalsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.prototype.setBillingEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListBillingIntervalsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListBillingIntervalsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListBillingIntervalsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    v3_types_billing_interval_pb.BillingInterval.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v3_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListBillingIntervalsResponse}
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListBillingIntervalsResponse;
  return proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListBillingIntervalsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListBillingIntervalsResponse}
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_billing_interval_pb.BillingInterval;
      reader.readMessage(value,v3_types_billing_interval_pb.BillingInterval.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = new v3_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v3_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListBillingIntervalsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v3_types_billing_interval_pb.BillingInterval.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v3_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BillingInterval items = 1;
 * @return {!Array<!proto.loopup.ctgateway.v3.BillingInterval>}
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.BillingInterval>} */ (
    jspb.Message.getRepeatedWrapperField(this, v3_types_billing_interval_pb.BillingInterval, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.BillingInterval>} value
 * @return {!proto.loopup.ctgateway.v3.ListBillingIntervalsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.BillingInterval=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.BillingInterval}
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v3.BillingInterval, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.ListBillingIntervalsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v3.PaginationInfo}
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v3_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v3.ListBillingIntervalsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.ListBillingIntervalsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.ListBillingIntervalsResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingIntervalId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest}
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest;
  return proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest}
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingIntervalId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingIntervalId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string billing_interval_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.prototype.getBillingIntervalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.prototype.setBillingIntervalId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    v3_types_invoice_line_item_pb.InvoiceLineItem.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v3_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse}
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse;
  return proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse}
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_invoice_line_item_pb.InvoiceLineItem;
      reader.readMessage(value,v3_types_invoice_line_item_pb.InvoiceLineItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = new v3_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v3_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v3_types_invoice_line_item_pb.InvoiceLineItem.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v3_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated InvoiceLineItem items = 1;
 * @return {!Array<!proto.loopup.ctgateway.v3.InvoiceLineItem>}
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.InvoiceLineItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, v3_types_invoice_line_item_pb.InvoiceLineItem, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.InvoiceLineItem>} value
 * @return {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.InvoiceLineItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.InvoiceLineItem}
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v3.InvoiceLineItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v3.PaginationInfo}
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v3_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.ListInvoiceLineItemsResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProductId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest;
  return proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurchasedProductId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProductId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string purchased_product_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.prototype.getPurchasedProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.prototype.setPurchasedProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.repeatedFields_ = [1,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    v3_types_group_pb.Group.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v3_types_pagination_pb.PaginationInfo.toObject(includeInstance, f),
    contributingGroupsList: jspb.Message.toObjectList(msg.getContributingGroupsList(),
    v3_types_purchased_product_pb.ContributingGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse;
  return proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_group_pb.Group;
      reader.readMessage(value,v3_types_group_pb.Group.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    case 2:
      var value = new v3_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v3_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    case 3:
      var value = new v3_types_purchased_product_pb.ContributingGroup;
      reader.readMessage(value,v3_types_purchased_product_pb.ContributingGroup.deserializeBinaryFromReader);
      msg.addContributingGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v3_types_group_pb.Group.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v3_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
  f = message.getContributingGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      v3_types_purchased_product_pb.ContributingGroup.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Group groups = 1;
 * @return {!Array<!proto.loopup.ctgateway.v3.Group>}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.Group>} */ (
    jspb.Message.getRepeatedWrapperField(this, v3_types_group_pb.Group, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.Group>} value
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.prototype.setGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.Group=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.Group}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v3.Group, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v3.PaginationInfo}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v3_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated ContributingGroup contributing_groups = 3;
 * @return {!Array<!proto.loopup.ctgateway.v3.ContributingGroup>}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.prototype.getContributingGroupsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.ContributingGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, v3_types_purchased_product_pb.ContributingGroup, 3));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.ContributingGroup>} value
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.prototype.setContributingGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.ContributingGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.ContributingGroup}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.prototype.addContributingGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.loopup.ctgateway.v3.ContributingGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListPurchasedProductGroupContributionsResponse.prototype.clearContributingGroupsList = function() {
  return this.setContributingGroupsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    purchasedProductId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    effectiveFromDateTime: (f = msg.getEffectiveFromDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest}
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest;
  return proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest}
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurchasedProductId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveFromDateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPurchasedProductId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEffectiveFromDateTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string purchased_product_id = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.prototype.getPurchasedProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.prototype.setPurchasedProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp effective_from_date_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.prototype.getEffectiveFromDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest} returns this
*/
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.prototype.setEffectiveFromDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.prototype.clearEffectiveFromDateTime = function() {
  return this.setEffectiveFromDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductRequest.prototype.hasEffectiveFromDateTime = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    group: (f = msg.getGroup()) && v3_types_purchased_product_pb.ContributingGroup.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse}
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse;
  return proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse}
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_purchased_product_pb.ContributingGroup;
      reader.readMessage(value,v3_types_purchased_product_pb.ContributingGroup.deserializeBinaryFromReader);
      msg.setGroup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroup();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v3_types_purchased_product_pb.ContributingGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional ContributingGroup group = 1;
 * @return {?proto.loopup.ctgateway.v3.ContributingGroup}
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse.prototype.getGroup = function() {
  return /** @type{?proto.loopup.ctgateway.v3.ContributingGroup} */ (
    jspb.Message.getWrapperField(this, v3_types_purchased_product_pb.ContributingGroup, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v3.ContributingGroup|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse} returns this
*/
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse.prototype.setGroup = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse} returns this
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse.prototype.clearGroup = function() {
  return this.setGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignGroupToPurchasedProductResponse.prototype.hasGroup = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProductId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    purchaseOrderReference: (f = msg.getPurchaseOrderReference()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    effectiveFromDateTime: (f = msg.getEffectiveFromDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endDateTime: (f = msg.getEndDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    sku: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest;
  return proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurchasedProductId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPurchaseOrderReference(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveFromDateTime(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDateTime(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSku(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProductId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPurchaseOrderReference();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEffectiveFromDateTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDateTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSku();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string purchased_product_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.getPurchasedProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.setPurchasedProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue purchase_order_reference = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.getPurchaseOrderReference = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.setPurchaseOrderReference = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.clearPurchaseOrderReference = function() {
  return this.setPurchaseOrderReference(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.hasPurchaseOrderReference = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp effective_from_date_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.getEffectiveFromDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.setEffectiveFromDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.clearEffectiveFromDateTime = function() {
  return this.setEffectiveFromDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.hasEffectiveFromDateTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp end_date_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.getEndDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.setEndDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.clearEndDateTime = function() {
  return this.setEndDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.hasEndDateTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string sku = 5;
 * @return {string}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.getSku = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductRequest.prototype.setSku = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProduct: (f = msg.getPurchasedProduct()) && v3_types_purchased_product_pb.PerCallDurationPurchasedProduct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse;
  return proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_purchased_product_pb.PerCallDurationPurchasedProduct;
      reader.readMessage(value,v3_types_purchased_product_pb.PerCallDurationPurchasedProduct.deserializeBinaryFromReader);
      msg.setPurchasedProduct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v3_types_purchased_product_pb.PerCallDurationPurchasedProduct.serializeBinaryToWriter
    );
  }
};


/**
 * optional PerCallDurationPurchasedProduct purchased_product = 1;
 * @return {?proto.loopup.ctgateway.v3.PerCallDurationPurchasedProduct}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse.prototype.getPurchasedProduct = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PerCallDurationPurchasedProduct} */ (
    jspb.Message.getWrapperField(this, v3_types_purchased_product_pb.PerCallDurationPurchasedProduct, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PerCallDurationPurchasedProduct|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse} returns this
*/
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse.prototype.setPurchasedProduct = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse.prototype.clearPurchasedProduct = function() {
  return this.setPurchasedProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdatePerCallDurationPurchasedProductResponse.prototype.hasPurchasedProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProductId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ratesList: jspb.Message.toObjectList(msg.getRatesList(),
    v3_types_purchased_product_pb.PerCallDurationRate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest}
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest;
  return proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest}
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurchasedProductId(value);
      break;
    case 2:
      var value = new v3_types_purchased_product_pb.PerCallDurationRate;
      reader.readMessage(value,v3_types_purchased_product_pb.PerCallDurationRate.deserializeBinaryFromReader);
      msg.addRates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProductId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      v3_types_purchased_product_pb.PerCallDurationRate.serializeBinaryToWriter
    );
  }
};


/**
 * optional string purchased_product_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.prototype.getPurchasedProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest} returns this
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.prototype.setPurchasedProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated PerCallDurationRate rates = 2;
 * @return {!Array<!proto.loopup.ctgateway.v3.PerCallDurationRate>}
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.prototype.getRatesList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.PerCallDurationRate>} */ (
    jspb.Message.getRepeatedWrapperField(this, v3_types_purchased_product_pb.PerCallDurationRate, 2));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.PerCallDurationRate>} value
 * @return {!proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest} returns this
*/
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.prototype.setRatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.PerCallDurationRate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.PerCallDurationRate}
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.prototype.addRates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.loopup.ctgateway.v3.PerCallDurationRate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest} returns this
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesRequest.prototype.clearRatesList = function() {
  return this.setRatesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse}
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse;
  return proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse}
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.SetPerCallDurationPurchasedProductRatesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProductId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    minimumQuantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
    contributingDdiActivationStatus: jspb.Message.getFieldWithDefault(msg, 4, 0),
    effectiveFromDateTime: (f = msg.getEffectiveFromDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endDateTime: (f = msg.getEndDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    purchaseOrderReference: jspb.Message.getFieldWithDefault(msg, 7, ""),
    billingMechanism: (f = msg.getBillingMechanism()) && v3_types_billing_mechanism_pb.BillingMechanism.toObject(includeInstance, f),
    sku: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest;
  return proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurchasedProductId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinimumQuantity(value);
      break;
    case 4:
      var value = /** @type {!proto.loopup.ctgateway.v3.ContributingDdiActivationStatus} */ (reader.readEnum());
      msg.setContributingDdiActivationStatus(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveFromDateTime(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDateTime(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurchaseOrderReference(value);
      break;
    case 8:
      var value = new v3_types_billing_mechanism_pb.BillingMechanism;
      reader.readMessage(value,v3_types_billing_mechanism_pb.BillingMechanism.deserializeBinaryFromReader);
      msg.setBillingMechanism(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSku(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProductId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getMinimumQuantity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getContributingDdiActivationStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getEffectiveFromDateTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDateTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPurchaseOrderReference();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBillingMechanism();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      v3_types_billing_mechanism_pb.BillingMechanism.serializeBinaryToWriter
    );
  }
  f = message.getSku();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string purchased_product_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.getPurchasedProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.setPurchasedProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double price = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 minimum_quantity = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.getMinimumQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.setMinimumQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional ContributingDdiActivationStatus contributing_ddi_activation_status = 4;
 * @return {!proto.loopup.ctgateway.v3.ContributingDdiActivationStatus}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.getContributingDdiActivationStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v3.ContributingDdiActivationStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v3.ContributingDdiActivationStatus} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.setContributingDdiActivationStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp effective_from_date_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.getEffectiveFromDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.setEffectiveFromDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.clearEffectiveFromDateTime = function() {
  return this.setEffectiveFromDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.hasEffectiveFromDateTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp end_date_time = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.getEndDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.setEndDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.clearEndDateTime = function() {
  return this.setEndDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.hasEndDateTime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string purchase_order_reference = 7;
 * @return {string}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.getPurchaseOrderReference = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.setPurchaseOrderReference = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional BillingMechanism billing_mechanism = 8;
 * @return {?proto.loopup.ctgateway.v3.BillingMechanism}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.getBillingMechanism = function() {
  return /** @type{?proto.loopup.ctgateway.v3.BillingMechanism} */ (
    jspb.Message.getWrapperField(this, v3_types_billing_mechanism_pb.BillingMechanism, 8));
};


/**
 * @param {?proto.loopup.ctgateway.v3.BillingMechanism|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.setBillingMechanism = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.clearBillingMechanism = function() {
  return this.setBillingMechanism(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.hasBillingMechanism = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string sku = 9;
 * @return {string}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.getSku = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductRequest.prototype.setSku = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProduct: (f = msg.getPurchasedProduct()) && v3_types_purchased_product_pb.PerDdiPurchasedProduct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse;
  return proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_purchased_product_pb.PerDdiPurchasedProduct;
      reader.readMessage(value,v3_types_purchased_product_pb.PerDdiPurchasedProduct.deserializeBinaryFromReader);
      msg.setPurchasedProduct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v3_types_purchased_product_pb.PerDdiPurchasedProduct.serializeBinaryToWriter
    );
  }
};


/**
 * optional PerDdiPurchasedProduct purchased_product = 1;
 * @return {?proto.loopup.ctgateway.v3.PerDdiPurchasedProduct}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse.prototype.getPurchasedProduct = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PerDdiPurchasedProduct} */ (
    jspb.Message.getWrapperField(this, v3_types_purchased_product_pb.PerDdiPurchasedProduct, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PerDdiPurchasedProduct|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse} returns this
*/
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse.prototype.setPurchasedProduct = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse} returns this
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse.prototype.clearPurchasedProduct = function() {
  return this.setPurchasedProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdatePerDdiPurchasedProductResponse.prototype.hasPurchasedProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProductId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest;
  return proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurchasedProductId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProductId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string purchased_product_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.prototype.getPurchasedProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest} returns this
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.prototype.setPurchasedProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest} returns this
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest} returns this
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    v3_types_purchased_product_pb.PerCallDurationRate.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v3_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse;
  return proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_purchased_product_pb.PerCallDurationRate;
      reader.readMessage(value,v3_types_purchased_product_pb.PerCallDurationRate.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = new v3_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v3_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v3_types_purchased_product_pb.PerCallDurationRate.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v3_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PerCallDurationRate items = 1;
 * @return {!Array<!proto.loopup.ctgateway.v3.PerCallDurationRate>}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.PerCallDurationRate>} */ (
    jspb.Message.getRepeatedWrapperField(this, v3_types_purchased_product_pb.PerCallDurationRate, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.PerCallDurationRate>} value
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse} returns this
*/
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.PerCallDurationRate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.PerCallDurationRate}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v3.PerCallDurationRate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse} returns this
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v3.PaginationInfo}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v3_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse} returns this
*/
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse} returns this
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.ListPurchasedProductRatesResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest}
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest;
  return proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest}
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string billing_entity_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.prototype.getBillingEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.prototype.setBillingEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    v3_types_billing_adjustment_pb.BillingAdjustment.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v3_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse}
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse;
  return proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse}
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_billing_adjustment_pb.BillingAdjustment;
      reader.readMessage(value,v3_types_billing_adjustment_pb.BillingAdjustment.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = new v3_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v3_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v3_types_billing_adjustment_pb.BillingAdjustment.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v3_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BillingAdjustment items = 1;
 * @return {!Array<!proto.loopup.ctgateway.v3.BillingAdjustment>}
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.BillingAdjustment>} */ (
    jspb.Message.getRepeatedWrapperField(this, v3_types_billing_adjustment_pb.BillingAdjustment, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.BillingAdjustment>} value
 * @return {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.BillingAdjustment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.BillingAdjustment}
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v3.BillingAdjustment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v3.PaginationInfo}
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v3_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.ListBillingAdjustmentsResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    adjustmentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    effectiveFromDateTime: (f = msg.getEffectiveFromDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest}
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest;
  return proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest}
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjustmentId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveFromDateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdjustmentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getEffectiveFromDateTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string adjustment_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.prototype.getAdjustmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.prototype.setAdjustmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double amount = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp effective_from_date_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.prototype.getEffectiveFromDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.prototype.setEffectiveFromDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.prototype.clearEffectiveFromDateTime = function() {
  return this.setEffectiveFromDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentRequest.prototype.hasEffectiveFromDateTime = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingAdjustment: (f = msg.getBillingAdjustment()) && v3_types_billing_adjustment_pb.BillingAdjustment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse}
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse;
  return proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse}
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_billing_adjustment_pb.BillingAdjustment;
      reader.readMessage(value,v3_types_billing_adjustment_pb.BillingAdjustment.deserializeBinaryFromReader);
      msg.setBillingAdjustment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingAdjustment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v3_types_billing_adjustment_pb.BillingAdjustment.serializeBinaryToWriter
    );
  }
};


/**
 * optional BillingAdjustment billing_adjustment = 1;
 * @return {?proto.loopup.ctgateway.v3.BillingAdjustment}
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse.prototype.getBillingAdjustment = function() {
  return /** @type{?proto.loopup.ctgateway.v3.BillingAdjustment} */ (
    jspb.Message.getWrapperField(this, v3_types_billing_adjustment_pb.BillingAdjustment, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v3.BillingAdjustment|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse} returns this
*/
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse.prototype.setBillingAdjustment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse} returns this
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse.prototype.clearBillingAdjustment = function() {
  return this.setBillingAdjustment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdateBillingAdjustmentResponse.prototype.hasBillingAdjustment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupContributionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    effectiveFromDateTime: (f = msg.getEffectiveFromDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endDateTime: (f = msg.getEndDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest}
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest;
  return proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest}
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupContributionId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveFromDateTime(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupContributionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEffectiveFromDateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDateTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string group_contribution_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.prototype.getGroupContributionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.prototype.setGroupContributionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp effective_from_date_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.prototype.getEffectiveFromDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.prototype.setEffectiveFromDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.prototype.clearEffectiveFromDateTime = function() {
  return this.setEffectiveFromDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.prototype.hasEffectiveFromDateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp end_date_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.prototype.getEndDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.prototype.setEndDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.prototype.clearEndDateTime = function() {
  return this.setEndDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionRequest.prototype.hasEndDateTime = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    group: (f = msg.getGroup()) && v3_types_purchased_product_pb.ContributingGroup.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse}
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse;
  return proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse}
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_purchased_product_pb.ContributingGroup;
      reader.readMessage(value,v3_types_purchased_product_pb.ContributingGroup.deserializeBinaryFromReader);
      msg.setGroup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroup();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v3_types_purchased_product_pb.ContributingGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional ContributingGroup group = 1;
 * @return {?proto.loopup.ctgateway.v3.ContributingGroup}
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse.prototype.getGroup = function() {
  return /** @type{?proto.loopup.ctgateway.v3.ContributingGroup} */ (
    jspb.Message.getWrapperField(this, v3_types_purchased_product_pb.ContributingGroup, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v3.ContributingGroup|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse} returns this
*/
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse.prototype.setGroup = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse} returns this
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse.prototype.clearGroup = function() {
  return this.setGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdatePurchasedProductGroupContributionResponse.prototype.hasGroup = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupContributionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest;
  return proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupContributionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupContributionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string group_contribution_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest.prototype.getGroupContributionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest} returns this
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionRequest.prototype.setGroupContributionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse;
  return proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductGroupContributionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingIntervalId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest}
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest;
  return proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest}
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingIntervalId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingIntervalId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string billing_interval_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest.prototype.getBillingIntervalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest} returns this
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewRequest.prototype.setBillingIntervalId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingIntervalId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    invoicePreviewPdf: msg.getInvoicePreviewPdf_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse}
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse;
  return proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse}
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingIntervalId(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setInvoicePreviewPdf(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingIntervalId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInvoicePreviewPdf_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional string billing_interval_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.prototype.getBillingIntervalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse} returns this
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.prototype.setBillingIntervalId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes invoice_preview_pdf = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.prototype.getInvoicePreviewPdf = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes invoice_preview_pdf = 2;
 * This is a type-conversion wrapper around `getInvoicePreviewPdf()`
 * @return {string}
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.prototype.getInvoicePreviewPdf_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getInvoicePreviewPdf()));
};


/**
 * optional bytes invoice_preview_pdf = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getInvoicePreviewPdf()`
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.prototype.getInvoicePreviewPdf_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getInvoicePreviewPdf()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse} returns this
 */
proto.loopup.ctgateway.v3.GenerateInvoicePreviewResponse.prototype.setInvoicePreviewPdf = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.RemovePurchasedProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.RemovePurchasedProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProductId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.RemovePurchasedProductRequest}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.RemovePurchasedProductRequest;
  return proto.loopup.ctgateway.v3.RemovePurchasedProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.RemovePurchasedProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.RemovePurchasedProductRequest}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurchasedProductId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.RemovePurchasedProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.RemovePurchasedProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProductId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string purchased_product_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductRequest.prototype.getPurchasedProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.RemovePurchasedProductRequest} returns this
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductRequest.prototype.setPurchasedProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.RemovePurchasedProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.RemovePurchasedProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.RemovePurchasedProductResponse}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.RemovePurchasedProductResponse;
  return proto.loopup.ctgateway.v3.RemovePurchasedProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.RemovePurchasedProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.RemovePurchasedProductResponse}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.RemovePurchasedProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.RemovePurchasedProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemovePurchasedProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    ratesList: jspb.Message.toObjectList(msg.getRatesList(),
    v3_types_purchased_product_pb.PerCallDurationRate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest}
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest;
  return proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest}
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_purchased_product_pb.PerCallDurationRate;
      reader.readMessage(value,v3_types_purchased_product_pb.PerCallDurationRate.deserializeBinaryFromReader);
      msg.addRates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v3_types_purchased_product_pb.PerCallDurationRate.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PerCallDurationRate rates = 1;
 * @return {!Array<!proto.loopup.ctgateway.v3.PerCallDurationRate>}
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.prototype.getRatesList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.PerCallDurationRate>} */ (
    jspb.Message.getRepeatedWrapperField(this, v3_types_purchased_product_pb.PerCallDurationRate, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.PerCallDurationRate>} value
 * @return {!proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest} returns this
*/
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.prototype.setRatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.PerCallDurationRate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.PerCallDurationRate}
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.prototype.addRates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v3.PerCallDurationRate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest} returns this
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesRequest.prototype.clearRatesList = function() {
  return this.setRatesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse}
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse;
  return proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse}
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ValidatePurchasedProductRatesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.SendInvoiceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.SendInvoiceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.SendInvoiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.SendInvoiceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    invoiceId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.SendInvoiceRequest}
 */
proto.loopup.ctgateway.v3.SendInvoiceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.SendInvoiceRequest;
  return proto.loopup.ctgateway.v3.SendInvoiceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.SendInvoiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.SendInvoiceRequest}
 */
proto.loopup.ctgateway.v3.SendInvoiceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.SendInvoiceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.SendInvoiceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.SendInvoiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.SendInvoiceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvoiceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string invoice_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.SendInvoiceRequest.prototype.getInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.SendInvoiceRequest} returns this
 */
proto.loopup.ctgateway.v3.SendInvoiceRequest.prototype.setInvoiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.SendInvoiceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.SendInvoiceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.SendInvoiceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.SendInvoiceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.SendInvoiceResponse}
 */
proto.loopup.ctgateway.v3.SendInvoiceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.SendInvoiceResponse;
  return proto.loopup.ctgateway.v3.SendInvoiceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.SendInvoiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.SendInvoiceResponse}
 */
proto.loopup.ctgateway.v3.SendInvoiceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.SendInvoiceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.SendInvoiceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.SendInvoiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.SendInvoiceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.IssueInvoiceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.IssueInvoiceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.IssueInvoiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.IssueInvoiceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingIntervalId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.IssueInvoiceRequest}
 */
proto.loopup.ctgateway.v3.IssueInvoiceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.IssueInvoiceRequest;
  return proto.loopup.ctgateway.v3.IssueInvoiceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.IssueInvoiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.IssueInvoiceRequest}
 */
proto.loopup.ctgateway.v3.IssueInvoiceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingIntervalId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.IssueInvoiceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.IssueInvoiceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.IssueInvoiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.IssueInvoiceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingIntervalId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string billing_interval_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.IssueInvoiceRequest.prototype.getBillingIntervalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.IssueInvoiceRequest} returns this
 */
proto.loopup.ctgateway.v3.IssueInvoiceRequest.prototype.setBillingIntervalId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.IssueInvoiceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.IssueInvoiceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.IssueInvoiceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.IssueInvoiceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    invoiceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    invoiceNumber: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.IssueInvoiceResponse}
 */
proto.loopup.ctgateway.v3.IssueInvoiceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.IssueInvoiceResponse;
  return proto.loopup.ctgateway.v3.IssueInvoiceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.IssueInvoiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.IssueInvoiceResponse}
 */
proto.loopup.ctgateway.v3.IssueInvoiceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.IssueInvoiceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.IssueInvoiceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.IssueInvoiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.IssueInvoiceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvoiceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInvoiceNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string invoice_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.IssueInvoiceResponse.prototype.getInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.IssueInvoiceResponse} returns this
 */
proto.loopup.ctgateway.v3.IssueInvoiceResponse.prototype.setInvoiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string invoice_number = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v3.IssueInvoiceResponse.prototype.getInvoiceNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.IssueInvoiceResponse} returns this
 */
proto.loopup.ctgateway.v3.IssueInvoiceResponse.prototype.setInvoiceNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListInvoicesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListInvoicesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListInvoicesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListInvoicesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListInvoicesRequest}
 */
proto.loopup.ctgateway.v3.ListInvoicesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListInvoicesRequest;
  return proto.loopup.ctgateway.v3.ListInvoicesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListInvoicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListInvoicesRequest}
 */
proto.loopup.ctgateway.v3.ListInvoicesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListInvoicesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListInvoicesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListInvoicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListInvoicesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string billing_entity_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.ListInvoicesRequest.prototype.getBillingEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.ListInvoicesRequest} returns this
 */
proto.loopup.ctgateway.v3.ListInvoicesRequest.prototype.setBillingEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListInvoicesRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListInvoicesRequest} returns this
 */
proto.loopup.ctgateway.v3.ListInvoicesRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListInvoicesRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListInvoicesRequest} returns this
 */
proto.loopup.ctgateway.v3.ListInvoicesRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListInvoicesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListInvoicesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountReference: jspb.Message.getFieldWithDefault(msg, 2, ""),
    invoicesList: jspb.Message.toObjectList(msg.getInvoicesList(),
    v3_types_invoice_pb.Invoice.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v3_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListInvoicesResponse}
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListInvoicesResponse;
  return proto.loopup.ctgateway.v3.ListInvoicesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListInvoicesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListInvoicesResponse}
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountReference(value);
      break;
    case 3:
      var value = new v3_types_invoice_pb.Invoice;
      reader.readMessage(value,v3_types_invoice_pb.Invoice.deserializeBinaryFromReader);
      msg.addInvoices(value);
      break;
    case 4:
      var value = new v3_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v3_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListInvoicesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListInvoicesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountReference();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInvoicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      v3_types_invoice_pb.Invoice.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      v3_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string billing_entity_name = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.prototype.getBillingEntityName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.ListInvoicesResponse} returns this
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.prototype.setBillingEntityName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_reference = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.prototype.getAccountReference = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.ListInvoicesResponse} returns this
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.prototype.setAccountReference = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Invoice invoices = 3;
 * @return {!Array<!proto.loopup.ctgateway.v3.Invoice>}
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.prototype.getInvoicesList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.Invoice>} */ (
    jspb.Message.getRepeatedWrapperField(this, v3_types_invoice_pb.Invoice, 3));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.Invoice>} value
 * @return {!proto.loopup.ctgateway.v3.ListInvoicesResponse} returns this
*/
proto.loopup.ctgateway.v3.ListInvoicesResponse.prototype.setInvoicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.Invoice=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.Invoice}
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.prototype.addInvoices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.loopup.ctgateway.v3.Invoice, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.ListInvoicesResponse} returns this
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.prototype.clearInvoicesList = function() {
  return this.setInvoicesList([]);
};


/**
 * optional PaginationInfo pagination_info = 4;
 * @return {?proto.loopup.ctgateway.v3.PaginationInfo}
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v3_types_pagination_pb.PaginationInfo, 4));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v3.ListInvoicesResponse} returns this
*/
proto.loopup.ctgateway.v3.ListInvoicesResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.ListInvoicesResponse} returns this
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.ListInvoicesResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    invoiceId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest}
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest;
  return proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest}
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvoiceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string invoice_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest.prototype.getInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest} returns this
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfRequest.prototype.setInvoiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pdfArtifact: msg.getPdfArtifact_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse}
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse;
  return proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse}
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPdfArtifact(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPdfArtifact_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes pdf_artifact = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse.prototype.getPdfArtifact = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes pdf_artifact = 1;
 * This is a type-conversion wrapper around `getPdfArtifact()`
 * @return {string}
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse.prototype.getPdfArtifact_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPdfArtifact()));
};


/**
 * optional bytes pdf_artifact = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPdfArtifact()`
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse.prototype.getPdfArtifact_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPdfArtifact()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse} returns this
 */
proto.loopup.ctgateway.v3.GetIssuedInvoicePdfResponse.prototype.setPdfArtifact = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    invoiceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    format: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest}
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest;
  return proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest}
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceId(value);
      break;
    case 2:
      var value = /** @type {!proto.loopup.ctgateway.v3.FileFormat} */ (reader.readEnum());
      msg.setFormat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvoiceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFormat();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string invoice_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest.prototype.getInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest} returns this
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest.prototype.setInvoiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FileFormat format = 2;
 * @return {!proto.loopup.ctgateway.v3.FileFormat}
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest.prototype.getFormat = function() {
  return /** @type {!proto.loopup.ctgateway.v3.FileFormat} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v3.FileFormat} value
 * @return {!proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest} returns this
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownRequest.prototype.setFormat = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    artifact: msg.getArtifact_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse}
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse;
  return proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse}
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setArtifact(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArtifact_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes artifact = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse.prototype.getArtifact = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes artifact = 1;
 * This is a type-conversion wrapper around `getArtifact()`
 * @return {string}
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse.prototype.getArtifact_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getArtifact()));
};


/**
 * optional bytes artifact = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getArtifact()`
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse.prototype.getArtifact_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getArtifact()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse} returns this
 */
proto.loopup.ctgateway.v3.GetInvoiceSiteBreakdownResponse.prototype.setArtifact = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListBillRunsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListBillRunsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingPeriodStartDateTime: (f = msg.getBillingPeriodStartDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    billingPeriodEndDateTime: (f = msg.getBillingPeriodEndDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListBillRunsRequest}
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListBillRunsRequest;
  return proto.loopup.ctgateway.v3.ListBillRunsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListBillRunsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListBillRunsRequest}
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setBillingPeriodStartDateTime(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setBillingPeriodEndDateTime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListBillRunsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListBillRunsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingPeriodStartDateTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBillingPeriodEndDateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp billing_period_start_date_time = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.prototype.getBillingPeriodStartDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.ListBillRunsRequest} returns this
*/
proto.loopup.ctgateway.v3.ListBillRunsRequest.prototype.setBillingPeriodStartDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.ListBillRunsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.prototype.clearBillingPeriodStartDateTime = function() {
  return this.setBillingPeriodStartDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.prototype.hasBillingPeriodStartDateTime = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp billing_period_end_date_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.prototype.getBillingPeriodEndDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.ListBillRunsRequest} returns this
*/
proto.loopup.ctgateway.v3.ListBillRunsRequest.prototype.setBillingPeriodEndDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.ListBillRunsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.prototype.clearBillingPeriodEndDateTime = function() {
  return this.setBillingPeriodEndDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.prototype.hasBillingPeriodEndDateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 page_number = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListBillRunsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 page_size = 4;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListBillRunsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListBillRunsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.ListBillRunsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListBillRunsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListBillRunsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListBillRunsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillRunsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    v3_types_bill_run_pb.BillRun.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v3_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListBillRunsResponse}
 */
proto.loopup.ctgateway.v3.ListBillRunsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListBillRunsResponse;
  return proto.loopup.ctgateway.v3.ListBillRunsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListBillRunsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListBillRunsResponse}
 */
proto.loopup.ctgateway.v3.ListBillRunsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_bill_run_pb.BillRun;
      reader.readMessage(value,v3_types_bill_run_pb.BillRun.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = new v3_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v3_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListBillRunsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListBillRunsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListBillRunsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillRunsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v3_types_bill_run_pb.BillRun.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v3_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BillRun items = 1;
 * @return {!Array<!proto.loopup.ctgateway.v3.BillRun>}
 */
proto.loopup.ctgateway.v3.ListBillRunsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.BillRun>} */ (
    jspb.Message.getRepeatedWrapperField(this, v3_types_bill_run_pb.BillRun, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.BillRun>} value
 * @return {!proto.loopup.ctgateway.v3.ListBillRunsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListBillRunsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.BillRun=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.BillRun}
 */
proto.loopup.ctgateway.v3.ListBillRunsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v3.BillRun, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.ListBillRunsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListBillRunsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v3.PaginationInfo}
 */
proto.loopup.ctgateway.v3.ListBillRunsResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v3_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v3.ListBillRunsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListBillRunsResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.ListBillRunsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListBillRunsResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.ListBillRunsResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    invoiceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    csvArtifact: msg.getCsvArtifact_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest}
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest;
  return proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest}
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceId(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCsvArtifact(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvoiceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCsvArtifact_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional string invoice_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.prototype.getInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest} returns this
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.prototype.setInvoiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes csv_artifact = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.prototype.getCsvArtifact = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes csv_artifact = 2;
 * This is a type-conversion wrapper around `getCsvArtifact()`
 * @return {string}
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.prototype.getCsvArtifact_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCsvArtifact()));
};


/**
 * optional bytes csv_artifact = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCsvArtifact()`
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.prototype.getCsvArtifact_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCsvArtifact()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest} returns this
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordRequest.prototype.setCsvArtifact = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    artifact: msg.getArtifact_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse}
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse;
  return proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse}
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setArtifact(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArtifact_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes artifact = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse.prototype.getArtifact = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes artifact = 1;
 * This is a type-conversion wrapper around `getArtifact()`
 * @return {string}
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse.prototype.getArtifact_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getArtifact()));
};


/**
 * optional bytes artifact = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getArtifact()`
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse.prototype.getArtifact_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getArtifact()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse} returns this
 */
proto.loopup.ctgateway.v3.GetInvoiceCallDetailRecordResponse.prototype.setArtifact = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


goog.object.extend(exports, proto.loopup.ctgateway.v3);
